module.exports = __webpack_public_path__ + "static/media/objects_22.7a85d558.svg";